import React from 'react';
import { Box, Skeleton, alpha } from '@mui/material';

const HotelCardSkeleton = () => {
  return (
    <Box
      component="li"
      sx={{
        mb: 1.5,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        p: 1.5,
        borderRadius: 3,
        transition: 'all 0.2s ease',
        bgcolor: 'background.paper',
        '&:hover': {
          bgcolor: theme => alpha(theme.palette.primary.main, 0.04),
        }
      }}
    >
      {/* Brand Image Skeleton */}
      <Box sx={{ 
        width: 60,
        height: 60,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}>
        <Skeleton 
          variant="rounded" 
          width={48} 
          height={48}
          sx={{ 
            borderRadius: 2,
            bgcolor: theme => alpha(theme.palette.primary.main, 0.04),
            animation: 'fade 1.8s ease-in-out infinite',
            '@keyframes fade': {
              '0%': { opacity: 0.8 },
              '50%': { opacity: 0.4 },
              '100%': { opacity: 0.8 }
            }
          }}
        />
      </Box>

      {/* Hotel Info Skeleton */}
      <Box sx={{ 
        flex: 1,
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
      }}>
        {/* Hotel Name */}
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: 1,
          mb: 0.5,
        }}>
          <Skeleton 
            variant="text" 
            width="70%" 
            height={28}
            sx={{ 
              bgcolor: theme => alpha(theme.palette.primary.main, 0.04),
              borderRadius: 1,
              animation: 'fade 1.8s ease-in-out infinite'
            }}
          />
          {/* WIP Chip Skeleton */}
          <Skeleton 
            variant="rounded" 
            width={40} 
            height={24}
            sx={{ 
              borderRadius: 3,
              bgcolor: theme => alpha(theme.palette.primary.main, 0.03),
              animation: 'fade 1.8s ease-in-out infinite'
            }}
          />
        </Box>
        
        {/* ID | Ownership */}
        <Skeleton 
          variant="text" 
          width="60%" 
          height={20}
          sx={{ 
            bgcolor: theme => alpha(theme.palette.primary.main, 0.03),
            borderRadius: 1,
            animation: 'fade 1.8s ease-in-out infinite'
          }}
        />
      </Box>
    </Box>
  );
};

export default HotelCardSkeleton; 